export const VUEX_ITEM_DISPLAY_FETCH_DATA = 'VUEX_ITEM_DISPLAY_FETCH_DATA'
export const VUEX_ITEM_DISPLAY_SET_ITEM = 'VUEX_ITEM_DISPLAY_SET_ITEM'
export const VUEX_ITEM_DISPLAY_UPDATE_QUERY = 'VUEX_ITEM_DISPLAY_UPDATE_QUERY'
